'use client';

import * as constructI18n from '@pigello/construct-i18n';
import { getDefaultLocaleCode } from './get-default-locale-code';

constructI18n.initConstructI18n({
  defaultLang: getDefaultLocaleCode(),
});
